import { RouterModule, Routes } from "@angular/router";

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReportsService } from "./reports.service";
import { SharedModule } from "src/app/template/shared/shared.module";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "generate-report",
        loadChildren: () =>
          import("./generate-report/generate.report.module").then(
            (m) => m.GenerateReportModule
          ),
        data: { breadcrumb: "Generate Report" },
      }
      // {
      //   path: "report-configuration",
      //   loadChildren: () =>
      //     import("./report-configuration/report-configuration.module").then(
      //       (m) => m.ReportConfigurationModule
      //     ),
      //   data: { breadcrumb: "Report Configuration" },
      // },
      // {
      //   path: "report-assignment",
      //   loadChildren: () =>
      //     import("./report-assignment/report-assignment.module").then(
      //       (m) => m.ReportAssignmentModule
      //     ),
      //   data: { breadcrumb: "Report Assignment" },
      // },
      // {
      //   path: "generate-report",
      //   loadChildren: () =>
      //     import("./generate-report/generate.report.module").then(
      //       (m) => m.GenerateReportModule
      //     ),
      //   data: { breadcrumb: "Generate Report" },
      // },
      // {
      //   path: "inventory-report",
      //   loadChildren: () =>
      //     import("./inventory-report/inventory-report.module").then(
      //       (m) => m.InventoryReportModule
      //     ),
      //   data: { breadcrumb: "Inventory Report" },
      // },
      // {
      //   path: "invoice-merge-report",
      //   loadChildren: () =>
      //     import("./invoice-file-upload/invoice-file-upload.module").then(
      //       (m) => m.InvoiceFileUploadModule
      //     ),
      //   data: { breadcrumb: "Invoice Merge Report" },
      // },
      // {
      //   path: "report-designer",
      //   loadChildren: () =>
      //     import("./report-designer/report-designer.module").then(
      //       (m) => m.ReportDesignerModule
      //     ),
      //   data: { breadcrumb: "Design Report" },
      // }
    ],
  },
];
@NgModule({
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes)],
  declarations: [],
  providers: [ReportsService],
})
export class ReportsModule {}
